// Parallax Begin

// parallaxMotionFunctions.js — vanilla JS version (no jQuery)

  // 1) Runner
  const run = () => {
    // Cache node lists once (sufficient for static WP pages)
    const covers = document.querySelectorAll('.jbg-parallax'); // parallax sections
    const fadeEls = document.querySelectorAll('.wp-block-cover__image-background'); // fade targets
    const bentoParallax = document.querySelectorAll('.jbg-bento.jbg-bento--parallax');

    const ENTRY_BUFFER = 150;   // anti-flicker buffer for bento
    const WRAPPER_SPEED = 0.22; // gentler than content parallax
    const TILE_SPEEDS = [
      ['.jbg-bento__leftTop',    0.10],
      ['.jbg-bento__text',       0.14],
      ['.jbg-bento__leftBottom', 0.16],
      ['.jbg-bento__rightTall',  0.06]
    ];

    function clamp(v, min, max) { return Math.min(Math.max(v, min), max); }

    function update() {
      const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      const winH = window.innerHeight || document.documentElement.clientHeight || 0;

      // 1) Parallax background + content slide
      covers.forEach((cover) => {
        const rect = cover.getBoundingClientRect();
        const height = rect.height || cover.offsetHeight || 0;

        // Only when in view
        if (rect.bottom <= 0 || rect.top >= winH) return;

        // Using rect.top: relY == -rect.top (distance element has moved into view)
        const relY = -rect.top;

        // Background parallax (transform smoother than background-position)
        const bg = cover.querySelector('.wp-block-cover__image-background, .wp-block-cover__video-background');
        if (bg) {
          const bgTranslate = relY * 0.3; // base speed
          bg.style.transform = 'translate3d(0,' + bgTranslate.toFixed(2) + 'px,0)';
        }

        // Content moves up (adjust speed to your taste)
        const content = cover.querySelector('.jbg-parallax-content');
        if (content) {
          const contentTranslate = -relY * 1.75; // negative = upward
          content.style.transform = 'translate3d(0,' + contentTranslate.toFixed(2) + 'px,0)';
        }
      });

      // 2) Original fade logic
      fadeEls.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const height = rect.height || el.offsetHeight || 1; // avoid divide by zero
        const opacity = (winH - rect.top) / height; // simplified from jQuery version
        el.style.opacity = String(clamp(opacity, 0, 1));
      });

      // 3) Bento block: wrapper + per-tile upward translate (toggle ON)
      bentoParallax.forEach((box) => {
        const rect = box.getBoundingClientRect();
        const inView = rect.bottom > -ENTRY_BUFFER && rect.top < winH + ENTRY_BUFFER;
        if (!inView) return; // no resets to avoid flicker

        // relY = -rect.top (relative scroll within the element)
        const relY = -rect.top;

        // Wrapper translate (slow, smooth)
        const wrapY = (-relY * WRAPPER_SPEED).toFixed(2);
        box.style.transform = 'translate3d(0,' + wrapY + 'px,0)';

        // Individual tiles (subtle, staggered drift)
        for (let i = 0; i < TILE_SPEEDS.length; i++) {
          const sel = TILE_SPEEDS[i][0], mult = TILE_SPEEDS[i][1];
          const tile = box.querySelector(sel);
          if (tile) {
            const ty = (-relY * mult).toFixed(2);
            tile.style.transform = 'translate3d(0,' + ty + 'px,0)';
          }
        }
      });

      requestAnimationFrame(update);
    }

    requestAnimationFrame(update);
  };

  // 2) Run when DOM is ready (whether this module loaded before or after)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }


// Parallax End